import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  setIsPatientDashboardData,
  setSelectedPatientDetailsData,
  setIsSelectedPatientData,
  getPatientListData,
  addNewPatientData,
  addNewPatientMatchData,
  setIsConsultationTabData,
  setConsultationStartedData,
  setPatientDashboardTabData,
  getPatientAppointmentsByIdData,
  getPaymentAnalyticsByPatientIdData,
  setOpenAddTemplateData,
  generateAiTemplateData,
  saveAiTemplateData,
  setShowStartConsultationModalData,
  showConsultationTypeModalData,
  setShowPrescriptionPreviewModalData,
  setPrescriptionImageBase64Data,
  generatePatientSummaryData,
  setPatientTranscriptionData,
  setPatientTabSwitcherData,
  setShowAddVitalsModalData,
  addPatientVitalsData,
  getPatientVitalsData,
  setpatientSummaryData,
  setpatientSummaryArrayData,
  setpatientCurrentSummaryArrayData,
  setpatientSummaryLoaderData,
  setSelectedPharmacyIdData,
  setSelectedPatientIdData,
  setPatientAiTemplateData,
  setIsSummaryGeneratedData,
  generateReferalLetterData,
  setReferralLetterData,
  setTogglePatientPanelOneData,
  setTogglePatientPanelTwoData,
  setFirstPatientPanelTitleData,
  setSecondPatientPanelTitleData,
  addPatientAllergiesData,
  setShowAddAllergiessModalData,
  getPatientAllergiesData,
  setPatientChatAnswersLoaderData,
  addPatientCondtionRelatedData,
  getPatientConditionRelatedData,
  getPatientMedicationsData,
  setShowAddPatientConditionModalData,
  setShowAddPatientMedicationModalData,
  addPatientMedicationsData,
  setPatientAIChatMessagesData,
  getAppointmentsByPharmacyIdData,
  savePatientAppointmentData,
  setTemplateStructureData,
  getPatientByKeywordData,
  updateConsultationActionsData,
  addPatientConsultationData,
  addupdateConsultationSummaryData,
  deleteConsultationActionData,
  deletePrescriptionDraftData,
  setConsultationIdData,
  getCompanyData,
  incrementPrescriptionCompleted,
  incrementPaymentCompleted,
  incrementReferralCompleted,
  incrementBookingCompleted,
  incrementVitalsCompleted,
  incrementVaccineCompleted,
  resetPatientQuickActionsState,
  setShowPatientDetailsEditModal,
  updatePatientDetailsData,
  setShowPreviousConsultationsModalData,
  getPatientConsultationsData,
  setIsChatReferralLetterData,
  setChatQuestionsData,
  setChatBotReferralLetterData,
  setPrevConsultationsDetailDataData,
  generateDemDXAssessmentsData,
  addPatientAIChatMessage,
  setAiChatSuccessMessagesData,
  getPatientByPatientIdData,
  setSelectedPatientConsultationData,
  setIsConsultationEnabledData,
  setOpenPatientForm,
  setNewPatientFormDefaultsData,
  setShowNoPatientCardData,
  setIsDemDXTemplateData,
  setIsSummaryStreamingData,
  setShowPatientReferralLetterModal,
  setShowPatientPrescriptionModal,
  setPatientPrescriptionData,
  setVaccinationImageBase64Data,
  setShowVaccinationPreviewModalData,
  setShowVaccineConfirmationModalData,
  setShowEditAiTemplateModal,
  setIsDemDXGlobalCheckData,
  setDemDxSummaryData,
  setIsDemDxActiveData,
  setDemDXForChatData,
  setisSummaryEnabledData,
  setDemDXPatientData,
  importPatientFromTitanData,
  SaveDemDxLogsAndSummaryData,
  saveAIChatMessageData,
  GetPatientVitalsSummaryByPatientIdData,
  updateConsultationStatusData,
  addConsultationTemplateData,
  updateConsultationTemplateData,
  setIsCallStartedData,
  openVitalsModal,
  closeVitalsModal,
  setOpenDeleteVitalsModal,
  updatePatientVitalsData,
  setIsPatientDetailsLoadingData,
  setConsultationEndedData,
  setPatientAllergyToEditData,
  setPatientAllergyToDeleteData,
  deletePatientAllergiesData,
  setPatientConditionRelatedToEditData,
  setPatientConditionRelatedToDeleteData,
  deletePatientConditionRelatedData,
  setPatientMedicationsToDeleteData,
  setPatientMedicationsToEditData,
  deletePatientMedicationsData,
  addPatientConsultationNotesData,
  setIsFinalSummaryData,
  setPatientNotesData,
  addConsultationFeedbackData,
  setPatientConsultationMediaButtonModeData,
  setDemDxSummaryTextData,
  setIsNotesExpandedData,
  addUpdatedTranscriptionData,
  setTranscriptData,
  setConsultationPausedData,
  addPatientConsentData,
  incrementSignatureCompleted,
  setShowAddPatientModalData,
  setConsultationStopAfterRefreshData,
  setShowPlayPauseBtnData,
  setFreeTypeModeData,
  setOpenSignatureDialogData,
  setSignatureDetailsData,
  addDeepGramTranscriptionData,
  getPatientConsultationsCountData,
  getAddressInformationUrlData,
  generateAiServiceTemplateData,
  updateConsultationButtonStatusData,
  updateConsentObtainedData,
  setIsLocallyCompletedData,
  generatePreConsultAiServiceTemplateData,
  setPreConsultationTemplateData,
  addAllergyOptimisticData,
  removeAllergyByIdData,
  setIsPatientListLoaderData,
  getConsultationAuditTimelineData,
  setPreConsultAddtoSummaryData,
  setPreConsultationTranscriptionData,
  getDoctorsBySearchData,
  searchSurgeryData,
  setSearchedDoctorsData,
  addPatientDocumentsData,
  getPatientDocumentsData,
  getPatientConsultationByConsultationIdData,
  renamePatientDocumentData,
  emailPatientDocumentData,
  deletePatientDocumentData,
  getPatientDocumentByIdData,
  getPatientVitalsChartsData,
  setVitalsDetailsData,
  setVaccineDetailsData,
  setOpenVaccineDialogData,
  setBookingDetailsData,
  setOpenBookingDialogData,
  setOpenRefDialogData,
  setLetterDetailsData,
  setConsultationAuditTimelineData,
  getPatientPrescriptionsByPatientIdData,
  setHasPreConsultData,
  setisHandleStartConsultationData,
  getPatientActiveConsultationData,
  setPrescriptionDetailsData,
  setOpenPrescriptionDialogData,
  setDynamicPrescriptionsData,
  setPrescriptionIdData,
  setIsPrescriptionUpdateData,
  setSelectedPrescriptionCategoryData,
  updateEventStatusData,
  setQuickActionsTabSwitchData,
  getAllDocumentsByEmailData,
  getCompanyTagsByCompanyIdData,
  setSelectedCompanyTagsData,
  addCompanyTagsData,
  deleteCompanyTagsData,
  getPatientByDemoGraphicsData,
  getPatientByNhsNumberData,
  trackServiceBillingData,
  summarizeConsultationSummariesData,
  setSelectedConsultationData,
  sendPatientQuestionnairesData,
  getPatientQuestionnairesByPatientyIdData,
  checkAndAddConsultationData,
  startConsultationFromQuestionnaireData,
  getPatientsListData,
  setIsShowPatientConsultationsLoader,
  SummarizeConsultationsActionsData,
  setPatientSummaryForActionsData,
  mergePatientDetailsData,
  getPreConsultationByConsultationIdData,
  setPreConsultImagePreviewData,
  setShowPreConsultImagePreviewModalData,
  getPatientConsultationCountByPatientIdData,
  importMultipleFromTitanData,
  getPatientsListV2Data,
  getPatientsListPowerSearchData,
  setFilteredPatientsData,
  setComingFromPatientListViewData,
  getPaymentAuditByConsultationData,
  setPaymentAuditData,
  getPatientConsentSignatureData,
  getReferalLetterByFilePathData,
  getPatientDocumentsByConsultationData,
  setPreConsultData,
  setPatientConsentSignatureData,
  sendMessageToMeshData,
  setNhs111FormData,
  setNhs111PrescriptionsData,
  setNhs111EmergencySupplyMedicationsData,
  setConsultationServiceCodeData,
  getPatientVaccinationByPatientIdData,
  setShowMultipleVaccineCertificatePreviewData,
  setMultipleVaccinationImageData,
  updateVitalAIChatMessage,
  updateAppointmentAIChatMessage,
  setViewOpenData,
  setisManualSubmitedData,
  updatePatientEthnicityData,
  generateVideoUploadUrlData,
  setImageDocsDetailsData,
  incrementImageUploadCompleted,
  setGeneratedVaccinationCertificateData,
  setHasPreConsultTabData,
  setTravelDestinationsData,
  getAllDestinationsData,
  getTravelOutbreaksData,
  setPatientConsultationsData,
  incrementTreatmentPlanCompleted,
  setTreatmentPlanDetailssData,
  updateTreatmentPlanAIChatMessage,
  setShowReferralLetterDialogData,
  updateTaskActionStatusData,
  setSnomedCodesData,
  setCompletedTasksForConsultationData,
  toggleCompletedTaskForConsultationData,
  removeTreatmentPlanAIChatMessage,
  setNhsContraceptionFormData,
  setNhsSinusitisFormData,
  setNhsUtiFormData,
  setNhsSoreThroatFormData,
  setNhsImpetigoFormData,
  setNhsInsectBitesFormData,
  setNhsShinglesFormData,
  setNhsAomFormData,
  setNhsAhtFormData,
  setShowPathwayCompletionModalData,
  setPendingCalculatorIdData,
  setHypertensionInitialFormData,
  setHypertensionABPMFittingFormData,
  getSurgeryByIdData,
  setSurgeryData,
  setisConsultationDataLoadingData,  
  accessRecordData,
  setAccessRecordData,
  setHypertensionABPMFollowupFormData,
  parseAbpmReportData,
  updatePatientSurgeryData,
  addNhsServiceClaimData,
} from "../features/patientSlice/patientSlice";
const reducerName = "patient";

export const setIsPatientDashboard = (value) => {
  dispatch(setIsPatientDashboardData(value));
};

export const setTravelDestinations = (value) => {
  dispatch(setTravelDestinationsData(value));
};

export const setHasPreConsultTab = (value) => {
  dispatch(setHasPreConsultTabData(value));
};

export const setIsSelectedPatient = (value) => {
  dispatch(setIsSelectedPatientData(value));
};

export const setSelectedPatientDetails = (value) => {
  dispatch(setSelectedPatientDetailsData(value));
};

export const setIsConsultationTab = (value) => {
  dispatch(setIsConsultationTabData(value));
};

export const setConsultationStarted = (value) => {
  dispatch(setConsultationStartedData(value));
};
export const setConsultationEnded = (value) => {
  dispatch(setConsultationEndedData(value));
};

export const setPatientDashboardTab = (value) => {
  dispatch(setPatientDashboardTabData(value));
};
export const setIsShowPatientConsultationsLoaderData = (value) => {
  dispatch(setIsShowPatientConsultationsLoader(value));
};
export const setOpenAddTemplate = (value) => {
  dispatch(setOpenAddTemplateData(value));
};
export const setShowStartConsultationModal = (value) => {
  dispatch(setShowStartConsultationModalData(value));
};
export const setShowConsultationTypeModal = (value) => {
  dispatch(showConsultationTypeModalData(value));
};
export const setShowPrescriptionPreviewModal = (value) => {
  dispatch(setShowPrescriptionPreviewModalData(value));
};
export const setPrescriptionImageBase64 = (value) => {
  dispatch(setPrescriptionImageBase64Data(value));
};
export const setShowVaccinationPreviewModal = (value) => {
  dispatch(setShowVaccinationPreviewModalData(value));
};
export const setVaccinationImageBase64 = (value) => {
  dispatch(setVaccinationImageBase64Data(value));
};
export const setShowVaccineConfirmationModal = (value) => {
  dispatch(setShowVaccineConfirmationModalData(value));
};
export const setPatientTranscription = (value) => {
  dispatch(setPatientTranscriptionData(value));
};
export const setPatientTabSwitcher = (value) => {
  dispatch(setPatientTabSwitcherData(value));
};
export const setShowAddVitalsModal = (value) => {
  dispatch(setShowAddVitalsModalData(value));
};
export const setPatientSummary = (value) => {
  dispatch(setpatientSummaryData(value));
};
export const setpatientSummaryArray = (value) => {
  dispatch(setpatientSummaryArrayData(value));
};
export const setpatientCurrentSummaryArray = (value) => {
  dispatch(setpatientCurrentSummaryArrayData(value));
};
export const setpatientSummaryLoader = (value) => {
  dispatch(setpatientSummaryLoaderData(value));
};
export const setSelectedPharmacyId = (value) => {
  dispatch(setSelectedPharmacyIdData(value));
};
export const setSelectedPatientId = (value) => {
  dispatch(setSelectedPatientIdData(value));
};
export const setIsSummaryGenerated = (value) => {
  dispatch(setIsSummaryGeneratedData(value));
};
export const setReferralLetter = (value) => {
  dispatch(setReferralLetterData(value));
};
export const setAiPatientTemplate = (value) => {
  dispatch(setPatientAiTemplateData(value));
};
export const setTogglePatientPanelOne = (value) => {
  dispatch(setTogglePatientPanelOneData(value));
};
export const setFirstPatientPanelTitle = (value) => {
  dispatch(setFirstPatientPanelTitleData(value));
};
export const setSecondPatientPanelTitle = (value) => {
  dispatch(setSecondPatientPanelTitleData(value));
};
export const setTogglePatientPanelTwo = (value) => {
  dispatch(setTogglePatientPanelTwoData(value));
};
export const setCurrentShowAddAllergiessModal = (value) => {
  dispatch(setShowAddAllergiessModalData(value));
};

export const setShowAddPatientConditionModal = (value) => {
  dispatch(setShowAddPatientConditionModalData(value));
};
export const setShowAddPatientMedicationModal = (value) => {
  dispatch(setShowAddPatientMedicationModalData(value));
};
export const setPatientChatAnswersLoader = (value) => {
  dispatch(setPatientChatAnswersLoaderData(value));
};

export const setUpdateTreatmentPlanAIChatMessage = (newMessage) => {
  dispatch(updateTreatmentPlanAIChatMessage(newMessage));
};

const parsePatientAIChatMessages = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      return parsePatientAIChatMessages(parsed);
    } catch (error) {
      return [];
    }
  }

  if (!value || typeof value !== "object") {
    return [];
  }

  const nestedPayload =
    value.json ?? value.Json ?? value.payload ?? value.Payload;

  if (nestedPayload !== undefined) {
    const nestedMessages = parsePatientAIChatMessages(nestedPayload);
    if (nestedMessages.length > 0) {
      return nestedMessages;
    }
  }

  const consultationChat =
    value.ConsultationChat ??
    value.ConsultaitonChat ??
    value.consultationChat ??
    value.PatientAIChatMessages ??
    value.patientAIChatMessages;

  if (consultationChat !== undefined) {
    return parsePatientAIChatMessages(consultationChat);
  }

  return [];
};

export const setPatientAIChatMessages = (value) => {
  dispatch(setPatientAIChatMessagesData(value));
};

export const setPatientAIChatMessagesFromConsultationPayload = (value) => {
  const messages = parsePatientAIChatMessages(value);
  dispatch(setPatientAIChatMessagesData(messages));
  return messages;
};
export const setTemplateStructure = (value) => {
  dispatch(setTemplateStructureData(value));
};
export const setConsultationId = (value) => {
  dispatch(setConsultationIdData(value));
};
export const setIncrementPrescriptionCompleted = (value) => {
  dispatch(incrementPrescriptionCompleted(value));
};
export const setIncrementPaymentCompleted = (value) => {
  dispatch(incrementPaymentCompleted(value));
};
export const setIncrementReferralCompleted = (value) => {
  dispatch(incrementReferralCompleted(value));
};
export const setIncrementBookingCompleted = (value) => {
  dispatch(incrementBookingCompleted(value));
};
export const setIncrementVitalsCompleted = (value) => {
  dispatch(incrementVitalsCompleted(value));
};
export const setIncrementVaccineCompleted = (value) => {
  dispatch(incrementVaccineCompleted(value));
};
export const resetPatientQuickActions = () => {
  dispatch(resetPatientQuickActionsState());
};
export const setCurrentShowPatientDetailsEditModal = (value) => {
  return dispatch(setShowPatientDetailsEditModal(value));
};
export const setIncrementSignatureCompleted = (value) => {
  dispatch(incrementSignatureCompleted(value));
};
export const setShowPreviousConsultationsModal = (value) => {
  dispatch(setShowPreviousConsultationsModalData(value));
};
export const setIsChatReferralLetter = (value) => {
  dispatch(setIsChatReferralLetterData(value));
};
export const setChatQuestions = (value) => {
  dispatch(setChatQuestionsData(value));
};
export const setChatBotReferralLetter = (value) => {
  dispatch(setChatBotReferralLetterData(value));
};
export const setPrevConsultationsDetailData = (value) => {
  dispatch(setPrevConsultationsDetailDataData(value));
};
export const setAddPatientAIChatMessage = (value) => {
  dispatch(addPatientAIChatMessage(value));
};

export const setUpdateVitalAIChatMessage = (newMessage) => {
  dispatch(updateVitalAIChatMessage(newMessage));
};

export const setUpdateAppointmentAIChatMessage = (newMessage) => {
  dispatch(updateAppointmentAIChatMessage(newMessage));
};

export const setAiChatSuccessMessages = (value) => {
  dispatch(setAiChatSuccessMessagesData());
};
export const setSelectedPatientConsultation = (value) => {
  dispatch(setSelectedPatientConsultationData(value));
};
export const setIsConsultationEnabled = (value) => {
  dispatch(setIsConsultationEnabledData(value));
};

export const openPatientForm = (value) => {
  return dispatch(setOpenPatientForm(value));
};
export const setNewPatientFormDefaults = (value) => {
  dispatch(setNewPatientFormDefaultsData(value));
};
export const setShowNoPatientCard = (value) => {
  dispatch(setShowNoPatientCardData(value));
};
export const setIsDemDXTemplate = (value) => {
  dispatch(setIsDemDXTemplateData(value));
};
export const setIsSummaryStreaming = (value) => {
  dispatch(setIsSummaryStreamingData(value));
};
export const setCurrentShowPatientReferralLetterModal = (value) => {
  dispatch(setShowPatientReferralLetterModal(value));
};
export const setCurrentShowPatientPrescriptionModal = (value) => {
  dispatch(setShowPatientPrescriptionModal(value));
};
export const setCurrentPatientPrescription = (value) => {
  dispatch(setPatientPrescriptionData(value));
};
export const setisManualSubmited = (value) => {
  dispatch(setisManualSubmitedData(value));
};
export const setCurrentShowEditAiTemplateModal = (
  show,
  template = null,
  selectedTemplateName = null,
) => {
  dispatch(
    setShowEditAiTemplateModal({
      show,
      template,
      selectedTemplateName,
    }),
  );
};

export const setIsDemDXGlobalCheck = (value) => {
  dispatch(setIsDemDXGlobalCheckData(value));
};
export const setDemDxSummary = (value) => {
  dispatch(setDemDxSummaryData(value));
};
export const setDemDxSummaryText = (value) => {
  dispatch(setDemDxSummaryTextData(value));
};
export const setIsDemDxActive = (value) => {
  dispatch(setIsDemDxActiveData(value));
};
export const setDemDXForChat = (value) => {
  dispatch(setDemDXForChatData(value));
};
export const setisSummaryEnabled = (value) => {
  dispatch(setisSummaryEnabledData(value));
};
export const setDemDXPatient = (value) => {
  dispatch(setDemDXPatientData(value));
};
export const setIsCallStarted = (value) => {
  dispatch(setIsCallStartedData(value));
};
export const setCurrentOpenVitalsModal = ({
  isEdit = false,
  vital = null,
  vitalType = null,
  vitalMessageId = null,
}) => {
  dispatch(openVitalsModal({ isEdit, vital, vitalType, vitalMessageId }));
};
export const setIsPatientDetailsLoading = (value) => {
  dispatch(setIsPatientDetailsLoadingData(value));
};
export const setIsFinalSummary = (value) => {
  dispatch(setIsFinalSummaryData(value));
};

export const setPatientNotes = (value) => {
  dispatch(setPatientNotesData(value));
};
export const setCurrentCloseVitalsModal = () => {
  dispatch(closeVitalsModal());
};
export const setCurrentOpenDeleteVitalsModal = (value) => {
  dispatch(setOpenDeleteVitalsModal(value));
};
export const setCurrentPatientAllergyToEdit = (value) => {
  dispatch(setPatientAllergyToEditData(value));
};
export const setCurrentPatientAllergyToDelete = (value) => {
  dispatch(setPatientAllergyToDeleteData(value));
};
export const setCurrentPatientConditionRelatedToEdit = (value) => {
  dispatch(setPatientConditionRelatedToEditData(value));
};
export const setCurrentPatientConditionRelatedToDelete = (value) => {
  dispatch(setPatientConditionRelatedToDeleteData(value));
};
export const setCurrentPatientMedicationsToEdit = (value) => {
  dispatch(setPatientMedicationsToEditData(value));
};
export const setCurrentPatientMedicationsToDelete = (value) => {
  dispatch(setPatientMedicationsToDeleteData(value));
};
export const setCurrentConsultationMediaButtonMode = (value) => {
  dispatch(setPatientConsultationMediaButtonModeData(value));
};
export const setIsNotesExpanded = (value) => {
  dispatch(setIsNotesExpandedData(value));
};
export const setTranscript = (value) => {
  dispatch(setTranscriptData(value));
};
export const setShowAddPatientModal = (value) => {
  dispatch(setShowAddPatientModalData(value));
};
export const setShowPlayPauseBtn = (value) => {
  dispatch(setShowPlayPauseBtnData(value));
};
export const setOpenSignatureDialog = (value) => {
  dispatch(setOpenSignatureDialogData(value));
};
export const setSignatureDetails = (value) => {
  dispatch(setSignatureDetailsData(value));
};
export const setConsultationPaused = (value) => {
  dispatch(setConsultationPausedData(value));
};
export const setConsultationStopAfterRefresh = (value) => {
  dispatch(setConsultationStopAfterRefreshData(value));
};
export const setFreeTypeMode = (value) => {
  dispatch(setFreeTypeModeData(value));
};
export const setIsLocallyCompleted = (value) => {
  dispatch(setIsLocallyCompletedData(value));
};
export const setPreConsultationTemplate = (value) => {
  dispatch(setPreConsultationTemplateData(value));
};
export const addAllergyOptimistic = (allergy) => {
  dispatch(addAllergyOptimisticData(allergy));
};

export const removeAllergyById = (id) => {
  dispatch(removeAllergyByIdData(id));
};
export const setIsPatientListLoader = (value) => {
  dispatch(setIsPatientListLoaderData(value));
};
export const setPreConsultationTranscription = (value) => {
  dispatch(setPreConsultationTranscriptionData(value));
};
export const setPreConsultAddtoSummary = (value) => {
  dispatch(setPreConsultAddtoSummaryData(value));
};
export const setSearchedDoctors = (value) => {
  dispatch(setSearchedDoctorsData(value));
};
export const setVitalsDetails = (value) => {
  dispatch(setVitalsDetailsData(value));
};
export const setVaccineDetails = (value) => {
  dispatch(setVaccineDetailsData(value));
};
export const setOpenVaccineDialog = (value) => {
  dispatch(setOpenVaccineDialogData(value));
};
export const setBookingDetails = (value) => {
  dispatch(setBookingDetailsData(value));
};
export const setOpenBookingDialog = (value, appointmentMessageId = null) => {
  if (typeof value === "boolean") {
    dispatch(setOpenBookingDialogData({ open: value, appointmentMessageId }));
  } else {
    dispatch(setOpenBookingDialogData({ ...value, appointmentMessageId }));
  }
};
export const setOpenRefDialog = (value) => {
  dispatch(setOpenRefDialogData(value));
};
export const setLetterDetails = (value) => {
  dispatch(setLetterDetailsData(value));
};
export const setHasPreConsult = (value) => {
  dispatch(setHasPreConsultData(value));
};
export const setisHandleStartConsultation = (value) => {
  dispatch(setisHandleStartConsultationData(value));
};
export const setConsultationAuditTimeline = (value) => {
  dispatch(setConsultationAuditTimelineData(value));
};
export const setPrescriptionDetails = (value) => {
  dispatch(setPrescriptionDetailsData(value));
};
export const setOpenPrescriptionDialog = (value) => {
  dispatch(setOpenPrescriptionDialogData(value));
};
export const setDynamicPrescriptions = (value) => {
  dispatch(setDynamicPrescriptionsData(value));
};
export const setPrescriptionId = (value) => {
  dispatch(setPrescriptionIdData(value));
};
export const setIsPrescriptionUpdate = (value) => {
  dispatch(setIsPrescriptionUpdateData(value));
};
export const setSelectedPrescriptionCategory = (value) => {
  dispatch(setSelectedPrescriptionCategoryData(value));
};
export const setQuickActionsTabSwitch = (value) => {
  dispatch(setQuickActionsTabSwitchData(value));
};
export const setSelectedCompanyTags = (value) => {
  dispatch(setSelectedCompanyTagsData(value));
};
export const setSurgery = (value) => {
  dispatch(setSurgeryData(value));
};
export const setisConsultationDataLoading = (value) => {
  dispatch(setisConsultationDataLoadingData(value));
};

export const setSelectedConsultation = (value) => {
  dispatch(setSelectedConsultationData(value));
};
export const setPatientSummaryForActions = (prompt) => {
  dispatch(setPatientSummaryForActionsData(prompt));
};
export const setPreConsultImagePreview = (value) => {
  dispatch(setPreConsultImagePreviewData(value));
};
export const setShowPreConsultImagePreviewModal = (value) => {
  dispatch(setShowPreConsultImagePreviewModalData(value));
};
export const setFilteredPatients = (value) => {
  dispatch(setFilteredPatientsData(value));
};
export const setComingFromPatientListView = (value) => {
  dispatch(setComingFromPatientListViewData(value));
};
export const setPaymentAudit = (value) => {
  dispatch(setPaymentAuditData(value));
};
export const setPreConsult = (value) => {
  dispatch(setPreConsultData(value));
};
export const setPatientConsentSignature = (value) => {
  dispatch(setPatientConsentSignatureData(value));
};
export const setNhs111Form = (value) => {
  dispatch(setNhs111FormData(value));
};
export const setNhs111Prescriptions = (value) => {
  dispatch(setNhs111PrescriptionsData(value));
};
export const setNhs111EmergencySupplyMedications = (value) => {
  dispatch(setNhs111EmergencySupplyMedicationsData(value));
};
export const setConsultationServiceCode = (value) => {
  dispatch(setConsultationServiceCodeData(value));
};
export const setShowMultipleVaccineCertificatePreview = (value) => {
  dispatch(setShowMultipleVaccineCertificatePreviewData(value));
};
export const setMultipleVaccinationImage = (value) => {
  dispatch(setMultipleVaccinationImageData(value));
};
export const setViewOpen = (value) => {
  dispatch(setViewOpenData(value));
};
export const setImageDocDetails = (value) => {
  dispatch(setImageDocsDetailsData(value));
};
export const setIncrementImageDocCompleted = (value) => {
  dispatch(incrementImageUploadCompleted(value));
};
export const setGeneratedVaccinationCertificate = (value) => {
  dispatch(setGeneratedVaccinationCertificateData(value));
};
export const setPatientConsultations = (value) => {
  dispatch(setPatientConsultationsData(value));
};
export const setTreatmentPlanDetails = (value) => {
  dispatch(setTreatmentPlanDetailssData(value));
};
export const setIncrementTreatmentPlanCompleted = (value) => {
  dispatch(incrementTreatmentPlanCompleted(value));
};
export const setSnomedCodes = (value) => {
  dispatch(setSnomedCodesData(value));
};
export const setShowReferralLetterDialog = (value) => {
  dispatch(setShowReferralLetterDialogData(value));
};
export const removePatientAIChatMessageByPlanId = (planId) => {
  dispatch(removeTreatmentPlanAIChatMessage(planId));
};
export const setNhsContraceptionForm = (value) => {
  dispatch(setNhsContraceptionFormData(value));
};
export const setNhsSinusitisForm = (value) => {
  dispatch(setNhsSinusitisFormData(value));
};
export const setNhsUtiForm = (value) => {
  dispatch(setNhsUtiFormData(value));
};
export const setNhsSoreThroatForm = (value) => {
  dispatch(setNhsSoreThroatFormData(value));
};
export const setNhsImpetigoForm = (value) => {
  dispatch(setNhsImpetigoFormData(value));
};
export const setNhsInsectBitesForm = (value) => {
  dispatch(setNhsInsectBitesFormData(value));
};
export const setNhsShinglesForm = (value) => {
  dispatch(setNhsShinglesFormData(value));
};
export const setNhsAomForm = (value) => {
  dispatch(setNhsAomFormData(value));
};
export const setNhsAhtForm = (value) => {
  dispatch(setNhsAhtFormData(value));
};
export const setShowPathwayCompletionModal = (value) => {
  dispatch(setShowPathwayCompletionModalData(value));
};
export const setPendingCalculatorId = (value) => {
  dispatch(setPendingCalculatorIdData(value));
};

export const setHypertensionInitialForm = (value) => {
  dispatch(setHypertensionInitialFormData(value));
};

export const setHypertensionABPMFittingForm = (value) => {
  dispatch(setHypertensionABPMFittingFormData(value));
};

export const setAccessRecord = (value) => {
  dispatch(setAccessRecordData(value));
};

export const setHypertensionABPMFollowupForm = (value) => {
  dispatch(setHypertensionABPMFollowupFormData(value));
};

// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const getPatientList = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientListData({
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }

  return result;
};

export const getAllDestinations = async () => {
  let result = null;
  try {
    result = await dispatch(getAllDestinationsData()).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const getTravelOutbreaks = async () => {
  let result = null;
  try {
    result = await dispatch(getTravelOutbreaksData()).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const addNewPatient = async (data) => {
  let result = null;
  try {
    result = await dispatch(addNewPatientData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const addNewPatientMatch = async (data) => {
  let result = null;
  try {
    result = await dispatch(addNewPatientMatchData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};

export const getPatientAppointmentsByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientAppointmentsByIdData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};

export const getPaymentAnalyticsByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPaymentAnalyticsByPatientIdData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};
export const generatePatientSummary = async (params) => {
  let result = [];
  try {
    result = await dispatch(generatePatientSummaryData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }

  return result;
};

export const generateAiTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(generateAiTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const saveAiTemplate = async (data) => {
  let result = null;

  try {
    result = await dispatch(saveAiTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }

  return result;
};

export const addPatientVitals = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientVitalsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const getPatientVitals = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientVitalsData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};
export const generateReferalLetter = async (params) => {
  let result = [];
  try {
    result = await dispatch(generateReferalLetterData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, params);
    result = [];
  }

  return result;
};

export const addPatientAllergies = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientAllergiesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getPatientAllergies = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientAllergiesData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};

export const addPatientCondtionRelated = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientCondtionRelatedData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getPatientConditionRelated = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientConditionRelatedData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};

export const addPatientMedications = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientMedicationsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const addPatientConsultation = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientConsultationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const getPatientMedications = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientMedicationsData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};

export const getAppointmentsByPharmacyId = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getAppointmentsByPharmacyIdData({
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }

  return result;
};

export const savePatientAppointment = async (data) => {
  let result = null;
  try {
    result = await dispatch(savePatientAppointmentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getPatientByKeyword = async (pharmacyId, keyword, companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientByKeywordData({
        pharmacyId,
        keyword,
        companyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const getPatientByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(getPatientByPatientIdData(patientId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }
  return result;
};
export const updateConsultationActions = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsultationActionsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const deleteConsultationAction = async (data) => {
  let result = null;
  try {
    result = await dispatch(deleteConsultationActionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const deletePrescriptionDraft = async (data) => {
  let result = null;
  try {
    result = await dispatch(deletePrescriptionDraftData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const updateConsultationStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsultationStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const addupdateConsultationSummary = async (data) => {
  let result = null;
  try {
    result = await dispatch(addupdateConsultationSummaryData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updatePatientDetails = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePatientDetailsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const getPatientConsultations = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientConsultationsData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }
};

export const getAllCompany = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(getCompanyData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);

    result = [];
  }
  return result;
};

export const generateDemDXAssessments = async (data) => {
  let result = null;
  try {
    result = await dispatch(generateDemDXAssessmentsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const importPatientFromTitan = async (data) => {
  let result = null;
  try {
    result = await dispatch(importPatientFromTitanData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const SaveDemDxLogsAndSummary = async (data) => {
  let result = null;
  try {
    result = await dispatch(SaveDemDxLogsAndSummaryData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const SaveAIChatMessage = async (data) => {
  let result = null;
  try {
    result = await dispatch(saveAIChatMessageData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
};

export const GetPatientVitalsSummaryByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      GetPatientVitalsSummaryByPatientIdData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }

  return result;
};
export const addConsultationTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(addConsultationTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    throw error;
  }
  return result;
};
export const updateConsultationTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsultationTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    throw error;
  }
  return result;
};
export const getPatientConsultationsCount = async (companyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientConsultationsCountData(companyId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
};

export const addPatientConsultationNotes = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientConsultationNotesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const updatePatientVitals = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePatientVitalsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const addConsultationFeedback = async (data) => {
  let result = null;
  try {
    result = await dispatch(addConsultationFeedbackData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
  }
};
export const deletePatientAllergies = async (data) => {
  let result = null;
  try {
    result = await dispatch(deletePatientAllergiesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const deletePatientConditionRelated = async (data) => {
  let result = null;
  try {
    result = await dispatch(deletePatientConditionRelatedData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const deletePatientMedications = async (data) => {
  let result = null;
  try {
    result = await dispatch(deletePatientMedicationsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const addUpdatedTranscription = async (data) => {
  let result = null;
  try {
    result = await dispatch(addUpdatedTranscriptionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const addPatientConsent = async (consultationId, data) => {
  let result = null;
  try {
    result = await dispatch(
      addPatientConsentData({ consultationId, data }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const addDeepGramTranscription = async (data) => {
  let result = null;
  try {
    result = await dispatch(addDeepGramTranscriptionData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const updateConsultationButtonStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsultationButtonStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const updateConsentObtained = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateConsentObtainedData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const getAddressInformation = async (postalCode) => {
  let result = null;
  try {
    result = await dispatch(getAddressInformationUrlData(postalCode)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const generateAiServiceTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(generateAiServiceTemplateData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const generatePreConsultAiServiceTemplate = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      generatePreConsultAiServiceTemplateData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getConsultationAuditTimeline = async (data) => {
  let result = null;
  try {
    result = await dispatch(getConsultationAuditTimelineData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getDoctorsBySearch = async (data) => {
  let result = null;
  try {
    result = await dispatch(getDoctorsBySearchData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const addPatientDocuments = async (data) => {
  let result = null;
  try {
    result = await dispatch(addPatientDocumentsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getPatientDocuments = async (patientId) => {
  let result = null;
  try {
    result = await dispatch(getPatientDocumentsData(patientId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getPatientConsultationByConsultationId = async (
  consultationId,
) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientConsultationByConsultationIdData({
        consultationId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, consultationId);
    result = [];
  }
  return result;
};

export const renamePatientDocument = async (data) => {
  let result = null;
  try {
    result = await dispatch(renamePatientDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const emailPatientDocument = async (data) => {
  let result = null;
  try {
    result = await dispatch(emailPatientDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deletePatientDocument = async (documentId) => {
  let result = null;
  try {
    result = await dispatch(deletePatientDocumentData(documentId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getPatientDocumentById = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientDocumentByIdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getPatientVitalsCharts = async (patientID, vitalName) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientVitalsChartsData({
        patientID,
        vitalName,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
  return result;
};

export const getPatientPrescriptionsByPatientId = async (patientId) => {
  let result = null;
  try {
    result = await dispatch(
      getPatientPrescriptionsByPatientIdData(patientId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getPatientActiveConsultation = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientActiveConsultationData({
        patientId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }
};
export const getAllDocumentsByEmail = async () => {
  let result = [];
  try {
    result = await dispatch(getAllDocumentsByEmailData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = [];
  }
};
export const updateEventStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateEventStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getCompanyTags = async (companyId) => {
  let result = null;
  try {
    result = await dispatch(getCompanyTagsByCompanyIdData(companyId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const addCompanyTags = async (data) => {
  let result = null;
  try {
    result = await dispatch(addCompanyTagsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const deleteCompanyTags = async (data) => {
  let result = null;
  try {
    result = await dispatch(deleteCompanyTagsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientByDemoGraphics = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientByDemoGraphicsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const trackServiceBilling = async (data) => {
  let result = null;
  try {
    result = await dispatch(trackServiceBillingData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};
export const summarizeConsultationSummaries = async (data) => {
  let result = null;
  try {
    dispatch(setIsSummaryGeneratedData(false));
    dispatch(setPatientSummaryForActionsData(null));
    result = await dispatch(summarizeConsultationSummariesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const getPatientByNhsNumber = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientByNhsNumberData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const SummarizeConsultationsActions = async (data) => {
  let result = null;
  try {
    result = await dispatch(SummarizeConsultationsActionsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const sendPatientQuestionnaires = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendPatientQuestionnairesData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const getPatientQuestionnairesByPatientyId = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      getPatientQuestionnairesByPatientyIdData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const checkAndAddConsultation = async (data) => {
  let result = null;
  try {
    result = await dispatch(checkAndAddConsultationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const startConsultationFromQuestionnaire = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      startConsultationFromQuestionnaireData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);

    result = null;
  }
  return result;
};

export const getPatientsList = async (pharmacyId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientsListData({
        pharmacyId,
      }),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, pharmacyId);
    result = [];
  }

  return result;
};

export const mergePatientDetails = async (data) => {
  let result = null;
  try {
    result = await dispatch(mergePatientDetailsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const getPreConsultationByConsultationId = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      getPreConsultationByConsultationIdData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientConsultationCountByPatientId = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      getPatientConsultationCountByPatientIdData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const importMultipleFromTitan = async (data) => {
  let result = null;
  try {
    result = await dispatch(importMultipleFromTitanData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientsListV2 = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientsListV2Data(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientsListPowerSearch = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientsListPowerSearchData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPaymentAuditByConsultation = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPaymentAuditByConsultationData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientConsentSignature = async (data) => {
  let result = null;
  try {
    result = await dispatch(getPatientConsentSignatureData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const getReferalLetterByFilePath = async (data) => {
  let result = null;
  try {
    result = await dispatch(getReferalLetterByFilePathData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getPatientDocumentsByConsultation = async (consultationId) => {
  let result = null;
  try {
    result = await dispatch(
      getPatientDocumentsByConsultationData(consultationId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const sendMessageToMesh = async (data) => {
  let result = null;
  try {
    result = await dispatch(sendMessageToMeshData(data)).unwrap();
  } catch (error) {
    result = null;
  }
  return result;
};
export const getPatientVaccinationByPatientId = async (patientId) => {
  let result = [];
  try {
    result = await dispatch(
      getPatientVaccinationByPatientIdData(patientId),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error, patientId);
    result = [];
  }
  return result;
};

export const updatePatientEthnicity = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePatientEthnicityData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    throw error;
  }
  return result;
};

export const generateVideoUploadUrl = async (data) => {
  let result = null;
  try {
    result = await dispatch(generateVideoUploadUrlData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const updateTaskActionStatus = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateTaskActionStatusData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const setCompletedTasksForConsultation = (consultationId, labels) => {
  dispatch(setCompletedTasksForConsultationData({ consultationId, labels }));
};

export const toggleCompletedTaskForConsultation = (consultationId, label) => {
  dispatch(toggleCompletedTaskForConsultationData({ consultationId, label }));
};

export const searchSurgery = async (data) => {
  let result = null;
  try {
    result = await dispatch(searchSurgeryData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};

export const getSurgeryById = async (data) => {
  let result = null;
  try {
    result = await dispatch(getSurgeryByIdData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const accessRecord = async (data) => {
  let result = null;
  try {
    result = await dispatch(accessRecordData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const parseAbpmReport = async (data) => {
  let result = null;
  try {
    result = await dispatch(parseAbpmReportData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const updatePatientSurgery = async (data) => {
  let result = null;
  try {
    result = await dispatch(updatePatientSurgeryData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
export const addNhsServiceClaim = async (data) => {
  let result = null;
  try {
    result = await dispatch(addNhsServiceClaimData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error, data);
    result = null;
  }
  return result;
};
